import React from 'react';
import './MonthViewSidebar.css';
import { getFeaturedEvents } from './calendar-api';

export default class MonthViewSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selected: this.props.active, daysWithFeaturedEvents: [] }
    this.getFullMonth = new Intl.DateTimeFormat('en-US', { month: 'long' }).format;
  }

  componentDidMount() {
    this.findFeaturedEvents();
  }

  componentDidUpdate(prev) {
    if (this.props.active !== prev.active) {
      this.setState({ selected: this.props.active });
    }
  }

  handleMonthChange(newMonth) {
    this.setState({ selected: newMonth, daysWithFeaturedEvents: [] }, this.findFeaturedEvents);
  }

  findFeaturedEvents() {
    const selected = this.state.selected;
    const beginningOfMonth = new Date(selected);
    beginningOfMonth.setDate(1);
    const endOfMonth = new Date(selected.getFullYear(), selected.getMonth() + 1, 0);

    getFeaturedEvents(beginningOfMonth, endOfMonth)
    .then(events => {
      const daysWithFeaturedEvents = [];
      for (let event of events) {
        if (!daysWithFeaturedEvents.includes(event.start.getDate())) {
          daysWithFeaturedEvents.push(event.start.getDate());
        }
      }
      this.setState({ daysWithFeaturedEvents });
    })
    .catch(console.error);
  }

  render() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    const lowerBound = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const upperBound = new Date(now.getFullYear(), now.getMonth() + 12, 1);

    const prev = new Date(
      this.state.selected.getFullYear(),
      this.state.selected.getMonth() - 1,
      1
    );

    const next = new Date(
      this.state.selected.getFullYear(),
      this.state.selected.getMonth() + 1,
      1
    );

    const daysInMonth = new Date(
      this.state.selected.getFullYear(),
      this.state.selected.getMonth() + 1,
      0
    ).getDate();

    const calendarDays = [];

    // get day of the week that the month starts on (0-6)
    const startDay = new Date(
      this.state.selected.getFullYear(),
      this.state.selected.getMonth(),
      0
    ).getDay();

    // pad calendar with empty buttons so that days align with the correct weekday
    for (let i = 0; i <= startDay; i++) {
      calendarDays.push(
        <button key={'day' + i} type="button" className="day"></button>
      );
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(this.state.selected.getFullYear(), this.state.selected.getMonth(), i);

      const classList = 'day ' 
      + (date < today ? 'past ' : '')
      + (date - this.props.active === 0 ? 'selected ' : '')
      + (this.state.daysWithFeaturedEvents.includes(i) ? 'featured ' : '')
      + (date - today === 0 ? 'today' : '');
      
      calendarDays.push(
        <button 
          key={'day' + date} 
          type="button" 
          className={classList} 
          onClick={() => this.props.changeSelectedDate(date)}
          >
          {i}
          </button>
      );
    }

    return(
      <section className="sidebar month">
        <div className="container">
          <div className="calendar">
            <header>
              <button
                type="button"
                className={`arrow-navigation left ${prev <= lowerBound ? '' : 'active'}`}
                onClick={() => prev > lowerBound && this.handleMonthChange(prev)}
              >
                <svg className="month-view-arrow" width="100%" height="100%" viewBox="0 0 38 31" fill="none"><path d="M18.7212 7.66049L19.1935 7.63437V7.16125V1.04498L37.2008 15.5541L19.1476 29.9613V23.702V23.202H18.6476H0.5V7.75754C0.607816 7.75666 0.731967 7.75574 0.871176 7.75478C1.39196 7.75117 2.12169 7.74703 2.99112 7.74251C4.7299 7.73348 7.02629 7.723 9.32492 7.71251L9.67281 7.71093C14.1375 7.69056 18.5404 7.67049 18.7212 7.66049Z" stroke="#D5AA55"></path></svg>
              </button>
              <h2>{this.getFullMonth(this.state.selected)}</h2>
              <button
                type="button"
                className={`arrow-navigation right ${next >= upperBound ? '' : 'active'}`}
                onClick={() => next < upperBound && this.handleMonthChange(next)}
              >
                <svg className="month-view-arrow" width="100%" height="100%" viewBox="0 0 38 31" fill="none"><path d="M18.7212 7.66049L19.1935 7.63437V7.16125V1.04498L37.2008 15.5541L19.1476 29.9613V23.702V23.202H18.6476H0.5V7.75754C0.607816 7.75666 0.731967 7.75574 0.871176 7.75478C1.39196 7.75117 2.12169 7.74703 2.99112 7.74251C4.7299 7.73348 7.02629 7.723 9.32492 7.71251L9.67281 7.71093C14.1375 7.69056 18.5404 7.67049 18.7212 7.66049Z" stroke="#D5AA55"></path></svg>
              </button>
            </header>
            <div className="body">
              <div className="day-indicators"><span className="weekday">S</span><span className="weekday">M</span><span className="weekday">T</span><span className="weekday">W</span><span className="weekday">T</span><span className="weekday">F</span><span className="weekday">S</span></div>
              <div className="days">
                { calendarDays }
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}